import axios from "axios";
import TokenService from "../Services/authentication/token.service";
import { ENV_CONFIG } from "./envConfig";
import { refershTokenApi } from "../Services/Users.service";

const apiInstance = axios.create({
  baseURL: ENV_CONFIG.apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Flag to prevent multiple refresh attempts
let isRefreshing = false;
let failedQueue: Array<{ resolve: Function; reject: Function }> = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  
  failedQueue = [];
};

apiInstance.interceptors.request.use(
  (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      if (!config.headers) config.headers = {};
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // If we're already refreshing, queue this request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return apiInstance(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const result = await refershTokenApi();
        
        if (result === "success") {
          const newToken = TokenService.getLocalAccessToken();
          if (newToken) {
            processQueue(null, newToken);
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return apiInstance(originalRequest);
          }
        }
        
        // If refresh failed, redirect to logout
        processQueue(new Error('Token refresh failed'), null);
        
        // Clear tokens and redirect to logout
        TokenService.clearAllTokens();
        const logoutUrl = ENV_CONFIG.logoutUrl;
        if (logoutUrl) {
          window.location.assign(logoutUrl);
        } else {
          window.location.reload();
        }
        
      } catch (refreshError: any) {
        console.error("Error during token refresh:", refreshError);
        processQueue(refreshError, null);
        
        // Clear tokens and redirect to logout
        TokenService.clearAllTokens();
        const logoutUrl = ENV_CONFIG.logoutUrl;
        if (logoutUrl) {
          window.location.assign(logoutUrl);
        } else {
          window.location.reload();
        }
        // Only redirect if it's an authentication-related error
        //   TokenService.clearAllTokens();
        //   localStorage.clear();
        //   window.location.href = window.location.origin;
      } finally {
        isRefreshing = false;
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiInstance;
